import Image from "~/components/atoms/Image";
import ascenderVerticalImage from "~/assets/ascender-logo-vertical.svg";
import facebookImage from "~/assets/social-facebook.png";
import instagramImage from "~/assets/social-instagram.png";
import tiktokImage from "~/assets/social-tiktok.png";
import twitterImage from "~/assets/social-twitter.png";
import youtubeImage from "~/assets/social-youtube.png";
import shopImage from "~/assets/shop-img-academy-logo-sm-w.svg";
import imgPlusAppImage from "~/assets/img-plus-app.png";
import ncsaAppImage from "~/assets/ncsa-app.png";
import appleAppStoreImage from "~/assets/apple-app-store.png";
import googlePlayStoreImage from "~/assets/google-play-store.png";
import { RouteIds, useRouteData } from "~/lib/routing";
import { cn } from "~/lib/utils";

function Social({ alt, href, src }: { alt: string; href: string; src: string }) {
    return (
        <a href={href} target="_blank">
            <Image alt={alt} className="size-[30px]" loading="lazy" src={src} />
        </a>
    );
}

function Main() {
    return (
        <div className="flex w-full max-w-[1200px] flex-col self-center p-[40px] text-white md:flex-row md:px-[15px]">
            <div className="mb-[30px] flex flex-1 flex-col items-center">
                <div className="mb-5">
                    <a href="https://www.imgacademy.com">
                        <Image
                            alt="IMG Academy Logo"
                            className="w-[140px]"
                            loading="lazy"
                            width="140px"
                            height="140px"
                            src={ascenderVerticalImage}
                        />
                    </a>
                </div>
                <div className="flex flex-row gap-[10px] py-[5px]">
                    <Social
                        alt="IMG Academy Youtube"
                        href="https://www.youtube.com/user/IMGAcademyMarketing"
                        src={youtubeImage}
                    />
                    <Social
                        alt="IMG Academy Instagram"
                        href="https://www.instagram.com/imgacademy/"
                        src={instagramImage}
                    />
                    <Social
                        alt="IMG Academy TikTok"
                        href="https://www.tiktok.com/@imgacademy"
                        src={tiktokImage}
                    />
                    <Social
                        alt="IMG Academy Twitter"
                        href="https://twitter.com/imgacademy"
                        src={twitterImage}
                    />
                    <Social
                        alt="IMG Academy Facebook"
                        href="https://www.facebook.com/IMGAcademy"
                        src={facebookImage}
                    />
                </div>
            </div>
            <div className="mb-[30px] flex flex-1 flex-row">
                <div className="mr-[10px] flex w-[calc(50%-10px)] flex-col gap-5 text-right md:mr-[20px] md:text-left lg:mr-[40px]">
                    <div className="text-[17px] font-normal leading-[1.1]">Contact</div>
                    <a href="https://goo.gl/maps/Ev45WSbnLdhwHY5t6" target="_blank">
                        <address className="text-[14px] not-italic leading-[1.45] sm:text-[15px]">
                            West Entrance (Main)
                            <br />
                            5650 Bollettieri Blvd.
                            <br />
                            Bradenton, FL 34210
                        </address>
                    </a>
                    <a href="https://goo.gl/maps/gQhJfqY9J4e18rK49" target="_blank">
                        <address className="text-[14px] not-italic leading-[1.45] sm:text-[15px]">
                            East Entrance
                            <br />
                            5500 34th St. W<br />
                            Bradenton, FL 34210
                        </address>
                    </a>
                    <div className="flex flex-col">
                        <a
                            className="py-[3px] text-[14px] leading-[1.45] sm:py-0.5 sm:text-[15px]"
                            href="tel:1-800-872-6425"
                        >
                            1-800-872-6425
                        </a>
                        <a
                            className="break-words py-[3px] text-[14px] leading-[1.45] sm:text-[15px]"
                            href="mailto:info@imgacademy.com"
                        >
                            info@imgacademy.com
                        </a>
                    </div>
                </div>
                <div className="ml-[10px] flex w-[calc(50%-10px)] flex-col gap-[15px] md:ml-0 md:mr-[20px] lg:mr-[40px]">
                    <div className="mb-[5px] text-[17px] font-normal leading-[1.1]">Links</div>
                    <a href="https://www.imgacademy.com/about-img-academy">About Us</a>
                    <a href="https://www.imgacademy.com/careers">Careers</a>
                    <a href="https://www.imgacademy.com/about-img-academy/media-brand">
                        Media & Brand
                    </a>
                    <a href="https://www.imgacademy.com/resources">Resources</a>
                    <a href="https://www.imgacademy.com/contact-us">Contact Us</a>
                    <a href="https://shop.imgacademy.com/">
                        <Image
                            alt="IMG Academy Shop"
                            className="w-[68px]"
                            loading="lazy"
                            src={shopImage}
                        />
                    </a>
                    <a href="https://www.imgacademy.com/travel-and-planning">Travel & Planning</a>
                    <a href="https://www.imgacademy.com/news">News</a>
                    <a href="https://www.imgacademy.com/sponsors">Sponsors</a>
                    <a href="https://www.imgacademy.com/nilpolicy">NIL Policy</a>
                    <a href="https://www.imgacademy.com/terms-service">Terms Of Service</a>
                </div>
            </div>
            <div className="mb-[30px] flex-1">
                <div className="mb-5 text-center text-[17px] font-normal leading-[1.1]">
                    Mobile Apps
                </div>
                <div className="flex flex-row">
                    <div className="m-[15px] flex w-[calc(50%-10px)] flex-col">
                        <Image
                            alt="IMG Academy Logo"
                            className="w-[75px] self-center"
                            loading="lazy"
                            width="75px"
                            height="75px"
                            src={imgPlusAppImage}
                        />
                        <div className="mt-[10.5px] text-center text-[15px] font-bold leading-[1.1]">
                            IMG Academy+
                        </div>
                        <div className="mb-5 text-center text-[11px] leading-none">
                            Mental Performance & Nutrition
                        </div>
                        <div className="mb-[15px] self-center">
                            <a
                                href="https://apps.apple.com/us/app/img-academy/id1581607815"
                                target="_blank"
                            >
                                <Image
                                    alt="IMG Academy+ App"
                                    className="w-[100px]"
                                    loading="lazy"
                                    width="100px"
                                    height="33px"
                                    src={appleAppStoreImage}
                                />
                            </a>
                        </div>
                    </div>
                    <div className="m-[15px] flex w-[calc(50%-10px)] flex-col">
                        <Image
                            alt="NCSA Logo"
                            className="w-[75px] self-center"
                            loading="lazy"
                            width="75px"
                            height="75px"
                            src={ncsaAppImage}
                        />
                        <div className="mt-[10.5px] text-center text-[15px] font-bold leading-[1.1]">
                            NCSA
                        </div>
                        <div className="mb-5 text-center text-[11px] leading-none">
                            Athlete Recruiting
                        </div>
                        <div className="mb-[15px] self-center">
                            <a
                                href="https://apps.apple.com/us/app/ncsa-athletic-recruiting/id673859348"
                                target="_blank"
                            >
                                <Image
                                    alt="NCSA Athletic Recruiting iOS App"
                                    className="w-[100px]"
                                    loading="lazy"
                                    width="100px"
                                    height="33px"
                                    src={appleAppStoreImage}
                                />
                            </a>
                        </div>
                        <div className="mb-[15px] self-center">
                            <a
                                href="https://play.google.com/store/apps/details?id=org.ncsasports.rms&amp;hl=en_US&amp;gl=US&amp;pli=1"
                                target="_blank"
                            >
                                <Image
                                    alt="NCSA Athletic Recruiting Android App"
                                    className="w-[100px]"
                                    loading="lazy"
                                    width="100px"
                                    height="33px"
                                    src={googlePlayStoreImage}
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function Legal() {
    return (
        <div className="flex w-full justify-center bg-white text-[14px] leading-[1.45] text-blue-80 sm:text-[15px]">
            <div className="flex w-full max-w-[1200px] flex-col items-center justify-between gap-[12px] p-[15px] text-center md:flex-row md:flex-wrap">
                <span className="basis-full lg:basis-auto">
                    ©2024 IMG Academy. All Rights Reserved
                </span>
                <a href="https://www.imgacademy.com/privacy-policy">Privacy Policy</a>
                <a href="https://www.imgacademy.com/purchase-policy">Purchase Policy</a>
                <a href="https://www.imgacademy.com/cookie-notice">Cookie Notice</a>
                <a href="https://www.imgacademy.com/california-privacy-rights">
                    California Privacy Rights
                </a>
                <a
                    href="https://www.imgacademy.com/manage-privacy-preferences"
                    aria-label="link to manage privacy settings"
                >
                    Manage Privacy Settings
                </a>
            </div>
        </div>
    );
}

interface Props {
    legalOnly?: boolean;
}

const Footer = ({ legalOnly }: Props) => {
    const { authenticated } = useRouteData(RouteIds.ROOT);

    return (
        <footer
            className={cn("flex flex-col font-light sm:pt-0", { "bg-blue-80": !authenticated })}
        >
            {!authenticated && !legalOnly && <Main />}
            <Legal />
        </footer>
    );
};
Footer.displayName = "Footer";

export default Footer;
